"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debounce = exports.default = debounce;
var _react = require("react");
// nui-widgets-v22: rename useDebounce and remove eslint-disable
function debounce(func) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 150;
  var timeout;
  var cleanup = function cleanup() {
    clearTimeout(timeout);
  };

  // eslint-disable-next-line react-hooks/rules-of-hooks
  (0, _react.useEffect)(function () {
    return cleanup;
  }, []);
  function debounced() {
    var _this = this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var later = function later() {
      func.apply(_this, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, delay);
  }
  debounced.clear = cleanup;
  return debounced;
}